import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import App from './App'
import { ReportPage } from './pages/Report'
import { SharePage } from './pages/Share'
import { ArticlePage } from './pages/Article'
import { OverloadScreen } from './components/OverloadScreen'
import { QueueGate } from './components/QueueGate'
import { initTelemetry } from './lib/telemetry'
import { installPageViewTracker } from './lib/track'
import { isOverloadModeEnabled } from './lib/overload'
import { usePulse } from './lib/pulse'
import './styles/global.css'

initTelemetry()
if (!isOverloadModeEnabled()) {
  installPageViewTracker()
}

function AppRoutes() {
  // 构建期强制过载（VITE_OVERLOAD_MODE）：真故障兜底，优先级最高
  if (isOverloadModeEnabled()) {
    return <OverloadScreen />
  }
  return <RuntimeRoutes />
}

/** 运行时档位路由：overload 档全站过载；queue 档仅次要入口轻等待；首页永不挡 */
function RuntimeRoutes() {
  const pulse = usePulse()
  if (pulse?.mode === 'overload') {
    return <OverloadScreen />
  }
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/report" element={<QueueGate><ReportPage /></QueueGate>} />
      <Route path="/share" element={<QueueGate><SharePage /></QueueGate>} />
      <Route path="/article/:slug" element={<QueueGate><ArticlePage /></QueueGate>} />
    </Routes>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </StrictMode>
)
